// eslint-disable-next-line import/no-unresolved
import { TypographyProps } from '@altibox/lte-salgskanaler-design-system-component-lib/dist/components/typography/types';
import React, { FC } from 'react';

import { StyledLink, StyledLinkProps } from './link.styled';
import { LinkTheme } from './link-types';

type Props = StyledLinkProps & React.AnchorHTMLAttributes<HTMLAnchorElement> & Omit<TypographyProps, 'component'>;

export const Link: FC<Props> = (props) => {
  const { $focusTheme = LinkTheme.LIGHT, ...rest } = props;

  return <StyledLink {...rest} $focusTheme={$focusTheme} component="a" />;
};
